import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Chip,
  Paper,
  Button,
  Select,
  Collapse,
  Checkbox,
  MenuItem,
  FormGroup,
  Typography,
  FormControl,
  FormControlLabel,
  SelectChangeEvent,
} from "@mui/material";

import {
  styledNewPdfFile,
  styledValidedPdfFile,
} from "PdfDocumentGrid/PdfDocumentCards/stylesPdfDocumentCards";
import FontAwesomeSvgIcon from "Layouts/Common/FontAwesomeSvgIcon";
import { RESOURCES_KEYS } from "utils/i18n/resources";
import {
  styledSortFilterZone,
  styledSortFilterZoneContent,
  styledSortFilterZoneCollapse,
} from "./stylesPdfDocumentsList";

import svgFonts from "Layouts/Common/fontAwesome";

export enum ORDER_VALUES {
  TITLE = "title",
  VERSION = "version",
  ACK_DATE = "ackDate",
  START_DATE = "startDate",
  CODE_ACTIVITY_AND_SERIAL_NUM_AND_LETTER = "codeActAndSerialNumAndLetter",
}

interface IFilterDocumentCardsProps {
  filters: { [key: string]: boolean };
  filterMenuStatus: boolean;
  orderValue: ORDER_VALUES;
  onToggleFilterStatus: () => void;
  onChangeSelect: (event: SelectChangeEvent) => void;
  onFiltersChanges: (key: string, value: boolean) => void;
}

const FilterDocumentCards: React.FunctionComponent<
  IFilterDocumentCardsProps
> = ({
  filterMenuStatus,
  orderValue,
  filters,
  onChangeSelect,
  onFiltersChanges,
  onToggleFilterStatus,
}) => {
  const { t: translate } = useTranslation();

  const handleOnChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    onFiltersChanges(target.name, target.checked);
  };

  const handleOnChangeOrderType = () =>
    onFiltersChanges("ascOrder", !filters.ascOrder);

  return (
    <Collapse
      in={filterMenuStatus}
      orientation="horizontal"
      sx={styledSortFilterZoneCollapse}
    >
      <Paper sx={styledSortFilterZone}>
        <Typography variant="h3" mb={2}>
          {translate(RESOURCES_KEYS.DOCUMENT_DISPAY_MANAGEMENT)}
        </Typography>
        <Box sx={styledSortFilterZoneContent}>
          <Typography variant="h4" mb={1}>
            {translate(RESOURCES_KEYS.ORDER_DOCUMENTS_BY)}
          </Typography>
          <Box display={"flex"}>
            <FormControl fullWidth={true}>
              <Select
                id="OrderBy"
                value={orderValue}
                onChange={onChangeSelect}
                defaultValue="title"
              >
                <MenuItem value={ORDER_VALUES.TITLE}>
                  {translate(RESOURCES_KEYS.TITLE)}
                </MenuItem>
                <MenuItem
                  value={ORDER_VALUES.CODE_ACTIVITY_AND_SERIAL_NUM_AND_LETTER}
                >
                  {translate(
                    RESOURCES_KEYS.CODE_ACTIVITY_AND_SERIAL_NUM_AND_LETTER
                  )}
                </MenuItem>
                {/* <MenuItem value={ORDER_VALUES.VERSION}>{translate(RESOURCES_KEYS.VERSION)}</MenuItem> */}
                <MenuItem value={ORDER_VALUES.START_DATE}>
                  {translate(RESOURCES_KEYS.START_DATE)}
                </MenuItem>
                {/* <MenuItem value={ORDER_VALUES.ACK_DATE}>{translate(RESOURCES_KEYS.ACK_DATE)}</MenuItem> */}
              </Select>
            </FormControl>
            <Button
              name="orderType"
              size="large"
              color="inherit"
              variant="outlined"
              aria-label="Ordre de tri"
              sx={{ ml: 1, px: 1, minWidth: "initial" }}
              onClick={handleOnChangeOrderType}
            >
              <span>
                <FontAwesomeSvgIcon
                  icon={
                    filters.ascOrder
                      ? svgFonts.faArrowUpShortWide
                      : svgFonts.faArrowDownShortWide
                  }
                />
              </span>
            </Button>
          </Box>
          <Typography variant="h4" mt={3} mb={1}>
            {translate(RESOURCES_KEYS.FILTER_DOCUMENTS)}
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="new"
                  checked={filters.new}
                  onChange={handleOnChange}
                />
              }
              label={
                <Chip
                  size="small"
                  color="secondary"
                  sx={styledNewPdfFile}
                  label={translate(RESOURCES_KEYS.NEW)}
                />
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="ack"
                  checked={filters.ack}
                  onChange={handleOnChange}
                />
              }
              label={
                <Chip
                  size="small"
                  color="error"
                  sx={styledValidedPdfFile}
                  label={
                    <>
                      <FontAwesomeSvgIcon
                        icon={svgFonts.faEnvelopeCircleCheck}
                      />
                    </>
                  }
                />
              }
            />
            {/* <FormControlLabel control={<Checkbox defaultChecked />} label='Documents importants' /> */}
          </FormGroup>
        </Box>
        <Box display={"flex"} justifyContent={"flex-end"}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={onToggleFilterStatus}
          >
            Fermer
          </Button>
          {/* <Button variant='outlined' color='primary' sx={{ ml: 1 }}>
              Enregistrer
            </Button>*/}
        </Box>
      </Paper>
    </Collapse>
  );
};
export default FilterDocumentCards;
